import { ResumeRecord } from './resumerecord';

export class ResumeWrapper {
    public sessionValid: any;
    public errorCode: any;
    public errorMessage: any;
    public errorMessageData: any;
    public verificationResult: any;
    public appExpiry: any;
    public profileStrengthInfo: any;
    public resumes: ResumeRecord[] = [];
}
